import { useSelector, useDispatch } from 'react-redux';
import FJVideoRemoveBgCustomExport from '../view/FJVideoRemoveBgCustomExport';
import { useCallback } from 'react';
import FJActionVideoRemoveBg from '../../../../redux/action/FJActionVideoRemoveBg';
import FJActionEditPage from '../../../../redux/action/FJActionEditPage.js';

const FJVideoRemoveBgCustomExportContainer = () => {
    const dispatch = useDispatch();
    const status = useSelector(state => state.videoBgRemover.customExportData.exportStatus);
    const progress = useSelector(state => state.videoBgRemover.customExportData.exportProgress);
    const isApplyButton = useSelector(state => state.common.isApplyButton);

    const download = useCallback(() => {
        dispatch(FJActionVideoRemoveBg.exportVideoAction());
    }, [dispatch]);

    const cancelExport = useCallback(() => {
        dispatch(FJActionVideoRemoveBg.cancelExportVideoAction());
    }, [dispatch]);

    const removeMore = useCallback(
        file => {
            dispatch(FJActionVideoRemoveBg.uploadCustomVideoAction(file));
        },
        [dispatch],
    );

    const _onEdit = () => {
        dispatch(FJActionVideoRemoveBg.onEditAction());
    };

    const _onClick = () => {
        dispatch(FJActionEditPage.openMediaLibraryAction());
    };

    return (
        <FJVideoRemoveBgCustomExport
            status={status}
            progress={progress}
            download={download}
            goToBack={cancelExport}
            removeMore={removeMore}
            cancelExport={cancelExport}
            isCustom={true}
            onEdit={_onEdit}
            onClick={_onClick}
            isApplyButton={isApplyButton}
        />
    );
};

export default FJVideoRemoveBgCustomExportContainer;
